import { EMPTY_OBJECT, EMPTY_STRING } from '../../../../constants/common'
import {
  PROFILE_ROUTE_NAMES,
  ROUTE_PATH_LIST_RENTAL_PORTAL,
} from '../../../../constants/route'
import { APPLICANTS_FILTER_PARAM } from '../../../RentalPortalApplicant'
import {
  getListingProfileLink,
  LISTINGS_FILTER_PARAM,
} from '../../../RentalPortalListing'
import { getRentalPortalSubsectionLink } from '../../RentalPortal.utils'
import { LISTINGS_FILTER_TOGGLE_VALUE } from '../../RentalPortalListings'
import {
  OVERVIEW_ATTENTION_REASON_KEY_BY_TYPE,
  OVERVIEW_ATTENTION_TYPE,
} from '../RentalPortalOverview.constants'
import { getOverviewViewingProfileLink } from '../RentalPortalOverviewViewingRow'

import {
  OVERVIEW_ATTENTION_PUBLISHINGS_TAB_SEGMENT,
  OVERVIEW_ATTENTION_REASON_VALUE_FIELD_BY_TYPE,
} from './RentalPortalOverviewAttentionRow.constants'

function getOverviewAttentionApplicantsLink(listingId) {
  return `${getRentalPortalSubsectionLink(ROUTE_PATH_LIST_RENTAL_PORTAL.applicants)}?${APPLICANTS_FILTER_PARAM.listing}=${listingId}`
}

function getOverviewAttentionPublishingsLink(listingId) {
  return PROFILE_ROUTE_NAMES.rentalPortalListingProfile({
    additionalParams: `/${OVERVIEW_ATTENTION_PUBLISHINGS_TAB_SEGMENT}`,
    id: listingId,
  })
}

function getOverviewAttentionReasonValues(row) {
  const valueField = OVERVIEW_ATTENTION_REASON_VALUE_FIELD_BY_TYPE[row.type]

  return valueField
    ? { count: row[valueField], [valueField]: row[valueField] }
    : EMPTY_OBJECT
}

export function getOverviewAttentionRowLink(row) {
  switch (row.type) {
    case OVERVIEW_ATTENTION_TYPE.newApplicants:
      return getOverviewAttentionApplicantsLink(row.listing_id)
    case OVERVIEW_ATTENTION_TYPE.portalError:
      return getOverviewAttentionPublishingsLink(row.listing_id)
    case OVERVIEW_ATTENTION_TYPE.stale:
      return getListingProfileLink(row.listing_id)
    case OVERVIEW_ATTENTION_TYPE.viewingOutcomeMissing:
      return getOverviewViewingProfileLink(row)
    default:
      return null
  }
}

export function getOverviewAttentionRowReason({ row, t }) {
  const reasonKey = OVERVIEW_ATTENTION_REASON_KEY_BY_TYPE[row.type]

  return reasonKey
    ? t(reasonKey, getOverviewAttentionReasonValues(row))
    : EMPTY_STRING
}

// TODO: the epic names the facet `attention`, the shipped RP-01 filter is
// `needs_my_action` — the deep link carries the filter the list actually reads
// until the naming settles.
export function getOverviewAttentionShowAllLink() {
  return `${getRentalPortalSubsectionLink(ROUTE_PATH_LIST_RENTAL_PORTAL.listings)}?${LISTINGS_FILTER_PARAM.needsMyAction}=${LISTINGS_FILTER_TOGGLE_VALUE}`
}
